import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mi hija ahora me pide "mamá, ¿hacemos una cita hoy?". Nos acercó como nunca imaginé.',
    author: 'María — mamá de 2 hijos',
    stars: 5
  }, {
    quote: 'Nos devolvió momentos que la rutina nos estaba robando sin que nos diéramos cuenta. Ojalá lo hubiera tenido antes.',
    author: 'Lucas — papá',
    stars: 5
  }, {
    quote: 'Ya no tengo que pensar qué hacer. Abro el libro, elijo una cita y listo. Mis hijos lo esperan cada semana.',
    author: 'Carolina — mamá',
    stars: 5
  }, {
    quote: 'No es un libro más. Es tiempo real con mis hijos. De esos momentos que después recordás toda la vida.',
    author: 'Andrea — mamá',
    stars: 5
  }, {
    quote: 'Mis hijos ahora me buscan para hacer las citas. Cambió completamente nuestra dinámica familiar. Es el mejor regalo que les di.',
    author: 'Roberto — papá de 3',
    stars: 5
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-231">
      <div className="max-w-3xl mx-auto" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-233">
          <div className="text-center mb-12" data-id="element-234">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-235">
              💬 FAMILIAS QUE YA ESTÁN CREANDO RECUERDOS
            </h2>
            <div className="w-24 h-2 bg-yellow-400 mx-auto rounded-full" data-id="element-236"></div>
          </div>

          <div className="space-y-6" data-id="element-237">
            {testimonials.map((t, idx) => <div key={idx} className="bg-gray-50 p-6 md:p-8 rounded-2xl border border-gray-200 shadow-sm relative" data-id="element-238">
                <div className="absolute top-4 right-6 text-4xl text-gray-200 font-serif" data-id="element-239">
                  "
                </div>
                <div className="flex text-yellow-400 mb-3" data-id="element-240">
                  {[...Array(t.stars)].map((_, i) => <svg key={i} className="w-6 h-6 fill-current" viewBox="0 0 20 20" data-id="element-241">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-242" />
                    </svg>)}
                </div>
                <p className="text-xl md:text-2xl font-bold text-gray-800 mb-4 italic leading-relaxed relative z-10" data-id="element-243">
                  "{t.quote}"
                </p>
                <p className="text-gray-600 font-bold uppercase tracking-wide text-sm" data-id="element-244">
                  {t.author}
                </p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}